export default "__VITE_ASSET__C8g6qSnW__"